import React from "react"
import { Link } from "react-router-dom"
import { cva } from "class-variance-authority"
import cn from "../../../utils/classes"

export type BadgeVariant =
  | "red"
  | "green"
  | "purple"
  | "info"
  | "blue"
  | "orphaned"
  | "none"

interface BadgeProps {
  text: string
  color: BadgeVariant
  to?: string
  className?: string
  styleOverrides?: string
  ariaLabel?: string
}

export const badgeVariants = cva(
  [
    "flex items-center justify-center rounded-md py-1 px-2 font-medium text-xs whitespace-nowrap w-fit leading-4",
  ],
  {
    variants: {
      color: {
        red: "bg-red-100 text-red-800",
        green: "bg-green-100 text-green-800",
        purple: "bg-purple-100 text-purple-800",
        info: "bg-blue-50 text-info-blue",
        blue: "bg-blue-500 text-white",
        orphaned: "bg-orphaned-100 text-orphaned-800",
        none: "bg-white text-gray-700",
      },
    },
  },
)

export const Badge: React.FC<BadgeProps> = ({
  text,
  color,
  to,
  className,
  styleOverrides,
  ariaLabel,
}) => {
  const classNames = cn(badgeVariants({ color }), className, styleOverrides)

  if (to) {
    return (
      <Link className={classNames} to={to} aria-label={ariaLabel}>
        {text}
      </Link>
    )
  }

  return (
    <div
      className={classNames}
      aria-label={ariaLabel}
      role={ariaLabel ? "status" : undefined}
    >
      {text}
    </div>
  )
}
